import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FCD34D",
      d: "M10 10c2.816-2.816 3.6-10 3.6-10S18.953 4.8 24 4.8 34.4 0 34.4 0s1.076 7.247 4 10c2.788 2.625 9.6 3.6 9.6 3.6s-4.8 4-4.8 10.4S48 34.4 48 34.4s-6.965 1.855-9.6 4.8c-2.375 2.655-4 8.8-4 8.8s-5.353-4.8-10.4-4.8S13.6 48 13.6 48s-1.332-6.103-3.6-8.8c-2.639-3.138-10-4.8-10-4.8S4.8 29.047 4.8 24 0 13.6 0 13.6s7.184-.784 10-3.6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#010C18",
      d: "M24.003 31.451a1.655 1.655 0 1 0 0-3.31 1.655 1.655 0 0 0 0 3.31M22.348 16.555h3.31v9.93h-3.31z"
    }, null, -1)
  ])))
}
export default { render: render }